module.exports = {"id":"199823","name":"Campaña","rating":"77","photo":"./data/images/photos/1/199823.png","club":{"name":"Levante UD","logo":"./data/images/clubs/LevanteUD.png"},"positions":["MDC","MOC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Campana0.json
// module id = 698
// module chunks = 0